import axios from "axios";
import { GET_ACTIVIDADES_EMPLEADOR } from "./obra";
export const GET_PUESTOS_TRABAJO = 'GET_PUESTOS_TRABAJO';


export const getPuestosTrabajo = () => (dispatch) => {
  return dispatch({
    type: GET_PUESTOS_TRABAJO,
    payload: axios
      .get(`afiliaciones/puestosTrabajo`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  })
}

export const getActividadesEmpleador = () => (dispatch) => {
  return dispatch({
    type: GET_ACTIVIDADES_EMPLEADOR,
    payload: axios
      .get(`afiliaciones/actividades`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  })
}